import t from "./highrise1525.mjs";
import e from "./highrise1529.mjs";
import o from "./highrise1530.mjs";
var i = "[object Null]", f = "[object Undefined]", r = t ? t.toStringTag : void 0;
function m(n) {
  return n == null ? n === void 0 ? f : i : r && r in Object(n) ? e(n) : o(n);
}
export {
  m as default
};
